<template>
  <section
    class="justify-content-center align-items-center"
    :class="{ scrollable }"
  >
    <div class="header">
      <h1>Portfolio</h1>
    </div>
    <div class="content">
      <div class="container mb-4 mb-md-5 mb-lg-0">
        <div class="row mb-5 mb-md-0">
          <div
            v-for="product in products"
            :key="product.slug"
            class="col-12 col-md-6 col-lg-3 text-left py-3 px-md-3 px-lg-2"
          >
            <div class="product-block">
              <div class="text-center">
                <img
                  :src="product.logo"
                  :style="{ 'background-color': product.color }"
                />
                <h2 class="text-left ml-3">{{ product.name }}</h2>
              </div>
              <div class="text">
                <p class="m-0">
                  {{ product.brief }}
                </p>
              </div>
              <div class="footer">
                <router-link
                  :to="`/portfolio/${product.slug}`"
                  class="link-ia dark"
                >
                  <span data-hover="Details ➜">
                    Details ➜
                  </span>
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-3 text-left py-3 px-md-3 px-lg-2">
            <div class="product-block get-yours">
              <div class="text-center block-head pl-3">
                <h2>Your awesome product can be here</h2>
              </div>
              <div class="text mt-auto">
                <router-link
                  :to="{ name: 'GetInTouch' }"
                  class="btn no-ui expand"
                >
                  GET A QUOTE <font-awesome-icon icon="plus" />
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import products from "@/assets/products";

export default {
  data() {
    return {
      products,
      scrollable: false
    };
  },
  mounted() {
    setTimeout(() => (this.scrollable = true), 1000);
  },
  methods: {
    onSelected(prod) {
      this.currentProduct = prod;
    }
  }
};
</script>

<style lang="scss" scoped>
section {
  background-image: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)),
    url("~@/assets/img/portfolio.jpg");

  background-size: cover;
  background-position: bottom;
  background-attachment: fixed;

  display: block;
  .header {
    height: 18vh;
    display: flex;
    align-items: center;
    justify-content: center;
    h1 {
      text-shadow: 0 0 6px #000000;
    }
    @media (min-width: 812px) {
      height: 20vh;
      h1 {
        font-size: 3em;
      }
    }
  }
  .content {
    display: flex;
    align-items: center;
    min-height: 82vh;
    @media (min-width: 812px) {
      min-height: 80vh;
    }
    background-color: #ffffff;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' width='1640' height='720' preserveAspectRatio='none' viewBox='0 0 1640 720'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1539%26quot%3b)' fill='none'%3e%3cpath d='M490.01 795.66C631.63 764.75 557.87 410.3 907.4 393.21 1256.92 376.12 1526.15 171.93 1742.17 170.01' stroke='rgba(86, 174, 253, 0.3)' stroke-width='2'%3e%3c/path%3e%3cpath d='M206.25 748.68C366.11 726.71 450.81 357.82 717.46 354.62 984.1 351.42 973.06 444.62 1228.66 444.62 1484.27 444.62 1610.1 354.96 1739.87 354.62' stroke='rgba(86, 174, 253, 0.6)' stroke-width='2'%3e%3c/path%3e%3cpath d='M837.73 850.38C989.21 827.05 1022.82 497.72 1313.49 463.74 1604.16 429.76 1649.76 180.21 1789.25 168.54' stroke='rgba(86, 174, 253, 0.3)' stroke-width='2'%3e%3c/path%3e%3cpath d='M612.43 724.04C795.1 677.32 820.49 210.41 1133.11 178.42 1445.73 146.43 1517.74 21.76 1653.79 20.02' stroke='rgba(86, 174, 253, 0.6)' stroke-width='2'%3e%3c/path%3e%3cpath d='M938.18 768.15C1105.75 697.49 1137.29 179.85 1360.51 175.85 1583.73 171.85 1653.86 463.2 1782.84 478.25' stroke='rgba(86, 174, 253, 0.6)' stroke-width='2'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1539'%3e%3crect width='1640' height='720' fill='white'%3e%3c/rect%3e%3c/mask%3e%3c/defs%3e%3c/svg%3e");
    // background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' width='1640' height='720' preserveAspectRatio='none' viewBox='0 0 1640 720'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1547%26quot%3b)' fill='none'%3e%3cpath d='M247.02 823.78C385.05 811.27 474.5 525.65 713.58 524.37 952.66 523.09 946.87 614.37 1180.15 614.37 1413.43 614.37 1527.92 524.78 1646.71 524.37' stroke='rgba(86, 174, 253, 0.3)' stroke-width='2'%3e%3c/path%3e%3cpath d='M133.75 788.83C356.64 777.18 497.59 394.72 928.12 381.39 1358.64 368.06 1513.61 125.44 1722.48 122.19' stroke='rgba(44%2c 45%2c 51%2c 0.11)' stroke-width='2'%3e%3c/path%3e%3cpath d='M633.26 750.9C781.71 700.85 692.26 285.87 1029.81 265.68 1367.35 245.49 1620.71 108.05 1822.9 107.28' stroke='rgba(86, 174, 253, 0.3)' stroke-width='2'%3e%3c/path%3e%3cpath d='M889.52 750.97C1009.84 706.96 960.36 348.64 1204.35 346.63 1448.33 344.62 1671.69 503.82 1834 505.03' stroke='rgba(44%2c 45%2c 51%2c 0.11)' stroke-width='2'%3e%3c/path%3e%3cpath d='M868.71 842.74C996.78 826.99 1026.34 571.65 1285 537.62 1543.66 503.59 1570.69 231.95 1701.29 213.62' stroke='rgba(44%2c 45%2c 51%2c 0.11)' stroke-width='2'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1547'%3e%3crect width='1640' height='720' fill='white'%3e%3c/rect%3e%3c/mask%3e%3c/defs%3e%3c/svg%3e");
    background-attachment: fixed;
    background-position-x: right;
    background-position-y: bottom;
    background-repeat: no-repeat;

    color: #2a2d34;

    .product-block {
      background-color: #ffffff;
      animation: fadeBottom 0.5s linear;
      animation-fill-mode: both;
      animation-delay: 0.4s;
      :nth-child(n + 4) {
        animation-delay: 0.5s;
      }

      display: flex;
      flex-direction: column;
      border-radius: 20px;
      overflow: hidden;
      box-shadow: 0px 0px 12px 0px rgb(0 0 0 / 11%);
      min-height: 287px;
      transition: all 0.4s ease;

      &:hover {
        cursor: pointer;
        transform: scale(1.04);
        box-shadow: 0 0px 20px 2px rgb(0 0 0 / 11%);
      }

      h2 {
        margin: 0.4rem 0 0.5rem;
      }
      img {
        padding: 1rem;
        width: 100%;
        height: 140px;
        object-fit: contain;
        object-position: center;
      }
      .text {
        padding: 0 1rem 1rem 1rem;
      }
      .footer {
        margin-top: auto;
        text-align: right;
        padding: 0 1rem 1rem 1rem;
      }

      &.get-yours {
        color: #ffffff;
        background-color: #4b95d7;

        h2 {
          text-transform: unset;
        }

        .block-head {
          height: 140px;
        }
        .block-head,
        .text {
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 140px;
        }

        a {
          color: #ffffff;
          text-decoration: none;
          border: 3px solid #ffffff;
          text-align: center;
          font-weight: 600;
          font-size: 1rem;
          padding: 0.7rem 2.5rem;
          &:hover {
            color: #ffffff;
          }
        }
      }
    }
  }
}

@keyframes fadeBottom {
  0% {
    opacity: 0;
    margin-top: 150px;
  }
  75% {
    opacity: 0.4;
    margin-top: 40px;
  }
  100% {
    margin-top: 0px;
    opacity: 1;
  }
}
</style>
